export default __webpack_public_path__ + "static/media/tio-emilio-icon.acd853a9.png";